import { render } from "./DynamicJsonForm.vue?vue&type=template&id=6420110d&scoped=true&ts=true"
import script from "./DynamicJsonForm.vue?vue&type=script&lang=ts"
export * from "./DynamicJsonForm.vue?vue&type=script&lang=ts"

import "./DynamicJsonForm.vue?vue&type=style&index=0&id=6420110d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6420110d"]])

export default __exports__